import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col, Typography, Button, Spin } from 'antd';
import { Icon } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import './housekeepingLinenChange.css';

const { Content } = Layout;
const { Text } = Typography;

@inject('housekeepingLinenChangeStore', 'loginStore')
@observer
class HousekeepingLinenChangePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        }

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.housekeepingLinenChangeStore.initHousekeepingLinenChange();
    }

    // ON CLICK Action

    backToHomePageOnClick = () => {
        this.props.history.push('/')
    }

    render() {
        const {
            housekeepingLinenChange,
            housekeepingLinenChangeLoading
        } = this.props.housekeepingLinenChangeStore;

        return (
            <Layout className='layout-page'>
                <Content>
                    <Row>
                        <Col span={24} className='col-header'>
                            <Row>
                                <Col span={4} className='col-header-back' onClick={this.backToHomePageOnClick}>
                                    <Icon type='left' size='lg' color='#FFF' />
                                </Col>
                                <Col span={16} className='col-header-text'>
                                    <Text className='text-header'>Housekeeping Linen Change</Text>
                                </Col>
                                <Col span={4} />
                            </Row>
                        </Col>
                    </Row>
                    <Row className='row-body-header'>
                        <Col span={24} className='col-body-header'>
                            <img src={require('../../assets/image/Banner/CleanRoom.svg')} alt='HousekeepingLinenChange' />
                        </Col>
                    </Row>

                    {
                        !housekeepingLinenChange
                            ?
                            <Row>
                                <Col span={24} className='housekeepinglinenchange-col-nodata'>
                                    <Spin spinning={true} tip='Loading data ...'>
                                    </Spin>
                                </Col>
                            </Row>
                            :
                            <Spin spinning={housekeepingLinenChangeLoading}>
                                <Row className='row-body-content'>
                                    <Col span={1} />
                                    <Col span={22} className='housekeepinglinenchange-col-container'>
                                        <Row>
                                            {housekeepingLinenChange.isSunday ?
                                                <Col span={24} className='housekeepinglinenchange-col-selected' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsSunday(false)}>Sunday</Col>
                                                :
                                                <Col span={24} className='housekeepinglinenchange-col' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsSunday(true)}>Sunday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingLinenChange.isMonday ?
                                                <Col span={24} className='housekeepinglinenchange-col-selected' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsMonday(false)}>Monday</Col>
                                                :
                                                <Col span={24} className='housekeepinglinenchange-col' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsMonday(true)}>Monday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingLinenChange.isTuesday ?
                                                <Col span={24} className='housekeepinglinenchange-col-selected' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsTuesday(false)}>Tuesday</Col>
                                                :
                                                <Col span={24} className='housekeepinglinenchange-col' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsTuesday(true)}>Tuesday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingLinenChange.isWednesday ?
                                                <Col span={24} className='housekeepinglinenchange-col-selected' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsWednesday(false)}>Wednesday</Col>
                                                :
                                                <Col span={24} className='housekeepinglinenchange-col' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsWednesday(true)}>Wednesday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingLinenChange.isThursday ?
                                                <Col span={24} className='housekeepinglinenchange-col-selected' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsThursday(false)}>Thursday</Col>
                                                :
                                                <Col span={24} className='housekeepinglinenchange-col' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsThursday(true)}>Thursday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingLinenChange.isFriday ?
                                                <Col span={24} className='housekeepinglinenchange-col-selected' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsFriday(false)}>Friday</Col>
                                                :
                                                <Col span={24} className='housekeepinglinenchange-col' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsFriday(true)}>Friday</Col>
                                            }
                                        </Row>
                                        <Row>
                                            {housekeepingLinenChange.isSaturday ?
                                                <Col span={24} className='housekeepinglinenchange-col-selected' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsSaturday(false)}>Saturday</Col>
                                                :
                                                <Col span={24} className='housekeepinglinenchange-col' onClick={() => this.props.housekeepingLinenChangeStore.setHousekeepingLinenChangeIsSaturday(true)}>Saturday</Col>
                                            }
                                        </Row>
                                    </Col>
                                    <Col span={1} />
                                </Row>
                            </Spin>
                    }

                    <Row>
                        <Col span={24} className='col-body-footer-confirm'>
                            <Row>
                                <Col span={1} />
                                <Col span={22} >
                                    <Button className='btn-body-footer-confirm-selected' onClick={() => this.props.housekeepingLinenChangeStore.updateHousekeepingLinenChange()}>Save</Button>
                                </Col>
                                <Col span={1} />
                            </Row>
                        </Col>
                    </Row>
                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(HousekeepingLinenChangePage)